// js
 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.swiper_cst', {
      slidesPerView: 6,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:6,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1.5,
        },
      },
    });
  });

// corporate gift box

 document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.gift-swiper', {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:4,
        },
        768: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1.5,
        },
      },
    });
  });

// shop the look

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.shop-look-slider', {
      slidesPerView:1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView:1,
        },
        768: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  });

// testimonal



document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.testimonal-slider', {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true, // autoplay के लिए loop true होना चाहिए
    autoplay: {
      delay: 3000, // 5 सेकंड का delay
      disableOnInteraction: false, // यूजर interaction के बाद भी autoplay continue रहे
    },
    // navigation हटाया गया
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      480: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
});

// Cart – "Move to Wishlist": add the line to the XB Wishlist (Swym) app, then
// remove it from the cart using the theme's own remove control so the drawer /
// cart page / bubble re-render natively.
(function () {
  function waitForSwym(cb) {
    if (window._swat && typeof window._swat.addToWishList === 'function') return cb(window._swat);
    if (!window.SwymCallbacks) window.SwymCallbacks = [];
    window.SwymCallbacks.push(cb);
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (window._swat && typeof window._swat.addToWishList === 'function') {
        clearInterval(poll);
        cb(window._swat);
      } else if (attempts > 40) {
        clearInterval(poll);
      }
    }, 500);
  }

  function removeLine(row) {
    var removeBtn = row.querySelector('cart-remove-button');
    if (removeBtn && typeof removeBtn.click === 'function') {
      removeBtn.click();
    } else {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: row.dataset.variantId, quantity: 0 }),
      }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
    }
  }

  function bindButtons(swat) {
    document.querySelectorAll('.cart-item__wishlist-btn').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var row = btn.closest('.cart-item');
        if (!row) return;
        var handle = row.dataset.productHandle;
        var label = btn.querySelector('span');
        var original = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = 'Moving…';

        function fail() {
          btn.disabled = false;
          if (label) label.textContent = original || 'Move to Wishlist';
        }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var variantId = parseInt(row.dataset.variantId, 10);
            var variant = (p.variants || []).filter(function (v) { return v.id === variantId; })[0] || (p.variants || [])[0];
            swat.addToWishList(
              {
                epi: variant ? variant.id : variantId,
                empi: p.id,
                du: window.location.origin + '/products/' + handle,
                iu: p.featured_image || '',
                pr: variant ? variant.price / 100 : 0,
                stk: variant && variant.available ? 1 : 0,
                dt: p.title,
              },
              function () { removeLine(row); },
              fail
            );
          })
          .catch(fail);
      });
    });
  }

  waitForSwym(function (swat) {
    bindButtons(swat);
    var observer = new MutationObserver(function () { bindButtons(swat); });
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  });
})();
